import React, { FC, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { useSelector } from "../../../../store/store";
import { getDDMMYYYFormat, getUCTDate } from "../../../../helper/dateTimeHelper";
import { TrainingService } from "../../../../services/training/training.service";
import { Col, Container, Row, Table } from "react-bootstrap";
import { Icon } from "../../../../modules/icon";
import { Button } from "../../../../modules/button";
import { courseStatus } from "../../../../constants/statusConstants";
import { CreateNotification } from "../../../../components/notifier";
import { MailService } from "../../../../services/mail/mail.service";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { getEnv } from "../../../../AppConfigs";
import _ from "lodash";

const previousPages = ["Plan", "Course", "Trainee"];
const siteUrl = getEnv("REACT_APP_AUTHOR_TRANING_PLAN_URL");
const approvalSiteUrl = getEnv("REACT_APP_APPROVER_TRANING_PLAN_URL");

export const ProcedureTrainingCourseDetailPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;
  const [course, setCourse] = useState(null as any);
  const [previousPage, setPreviousPage] = useState(previousPages[0]);
  const [approvalComment, setApprovalComment] = useState("");
  const [reviewComment, setReviewComment] = useState("");
  const [PageTitle, setPageTitle] = useState("");
  const [IsRegistration, setRegistration] = useState(false);
  const [trainees, setTrainees] = useState([]);
  const { id } = useRouteMatch().params as any;
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const employees = useSelector((state: any) => state.employee.employees);

  const getTrainingClassDetail = () => {
    return TrainingService.getTrainingCourseById(id).then(
      (res) => {
        setCourse(res);
        setApprovalComment(res.fields.eApprovedComment);
        setReviewComment(res.fields.eReviewComment);
      },
      () => {
        setCourse({});
      },
    );
  };

  const getTraineeByCourse = () => {
    return TrainingService.getTraineeByCourse(id).then(
      (res) => {
        setTrainees(res);
      },
      () => {
        setCourse([]);
      },
    );
  };

  const checkRegistration = () => {
    const employee: any = employees.find((o: any) => o.eMail.toLowerCase() === currentUserName.toLowerCase()) || null;
    setRegistration(_.some(trainees, (o: any) => o.employeeId === employee.eEmployeeId));
  };

  const sendMail = async (status: string, isReview: boolean) => {
    let sortName = "TCN";
    if (status !== courseStatus.rejected) {
      sortName = isReview ? "TCA" : "TCN";
    }
    const template = mailtemplates.find((m: any) => m.eMailType === sortName);
    const statusText = status === courseStatus.approved ? "duyệt" : "từ chối";
    let content = "";
    let subject = "";
    let message = {};
    if (sortName === "TCN") {
      content = template.eContent
        .replace(mailRegexs.zero, course.createdBy.user.displayName)
        .replace(mailRegexs.one, statusText)
        .replace(mailRegexs.siteUrl, siteUrl);
      subject = template.eSubject.replace("{0}", statusText);
      message = MailService.buildMailMesssage(subject, content, "html", course.createdBy.user.email);
    } else {
      const arr = course.fields.eApprovedBy.split("|");
      const name = arr.length > 1 ? arr[1] : "";
      const tomail = arr.length > 1 ? arr[0] : "";
      content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.siteUrl, approvalSiteUrl);
      subject = template.eSubject;
      message = MailService.buildMailMesssage(subject, content, "html", tomail);
    }

    await MailService.sendMail(message);
  };

  const onCancle = () => {
    history.goBack();
  };

  const onApply = () => {
    const employee: any = employees.find((o: any) => o.eMail.toLowerCase() === currentUserName.toLowerCase()) || null;
    const registration: any = {
      fields: {
        Title: `Đăng ký học lớp ${course.fields.Title}`,
        eEmployeeId: employee.eEmployeeId,
        eCourseId: id,
        eEmployeeData: JSON.stringify({
          employeeId: employee.eEmployeeId,
          name: employee.Title,
          department: employee.eDepartment,
        }),
      },
    };
    TrainingService.addTrainingCourseRegistration(registration)
      .then((res) => {
        CreateNotification({ title: "Thành công", body: `Đăng ký thành công.`, icon: "/icons/success.png" });
        goBack();
      })
      .catch((err) => {
        CreateNotification({ title: "Thất bại", body: `Đăng ký thất bại.`, icon: "/icons/error.png" });
      });
  };

  const onApproval = (status: any) => {
    const { fields } = course;
    fields.eApprovedComment = approvalComment;
    fields.eApprovedStatus = status;
    switch (status) {
      case courseStatus.rejected:
        fields.eStatus = courseStatus.close;
        break;
      case courseStatus.approved:
        fields.eStatus = courseStatus.open;
        break;
      default:
        break;
    }
    fields.eApprovedDate = getUCTDate();

    TrainingService.updateTrainingCourse(course.id, fields)
      .then((res) => {
        CreateNotification({ title: "Thành công", body: `Chỉnh sửa thành công.`, icon: "/icons/success.png" });
        sendMail(status, false);
        goBack();
      })
      .catch((err) => {
        CreateNotification({ title: "Thất bại", body: `Chỉnh sửa thất bại.`, icon: "/icons/error.png" });
      });
  };

  const onReview = (status: any) => {
    const { fields } = course;
    fields.eReviewComment = reviewComment;
    fields.eReviewedStatus = status;
    switch (status) {
      case courseStatus.rejected:
        fields.eStatus = courseStatus.close;
        break;
      case courseStatus.approved:
        fields.eStatus = courseStatus.waitingapproval;
        break;
      default:
        break;
    }
    fields.eReviewedDate = getUCTDate();

    TrainingService.updateTrainingCourse(course.id, fields)
      .then((res) => {
        CreateNotification({ title: "Thành công", body: `Chỉnh sửa thành công.`, icon: "/icons/success.png" });
        sendMail(status, true);
        goBack();
      })
      .catch((err) => {
        CreateNotification({ title: "Thất bại", body: `Chỉnh sửa thất bại.`, icon: "/icons/error.png" });
      });
  };

  const checkPreviousPage = () => {
    const pathname = history && history.location && history.location.pathname;
    if (pathname.indexOf("/training-plan/") > -1) {
      setPreviousPage(previousPages[0]);
      setPageTitle("Chi tiết lớp học");
    } else if (pathname.indexOf("/training-course/") > -1) {
      setPreviousPage(previousPages[1]);
      setPageTitle("Đăng ký lớp học");
    } else if (pathname.indexOf("/training-course-trainee/") > -1) {
      setPreviousPage(previousPages[2]);
      setPageTitle("Danh sách học viên");
    }
  };

  const goBack = () => {
    switch (previousPage) {
      case previousPages[0]:
        history.push(Routes.procedureTrainingPlan.path);
        break;
      case previousPages[1]:
        history.push(Routes.procedureTrainingCourse.path);
        break;
      case previousPages[2]:
        history.push(Routes.procedureTrainingStudent.path);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    getTrainingClassDetail();
    getTraineeByCourse();
    checkPreviousPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    checkRegistration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trainees]);

  return (
    <div className="ProcedureTrainingPlanPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={goBack}>
              <Icon.ArrowLeft />
            </div>
            {"Danh sách lớp học"}
          </div>
          {/* <div className="d-flex">
            <div className="px-1">
              <Button
                buttonType="info"
                label="Chỉnh sửa"
                onClick={() => history.push(Routes.procedureTrainingCourseCreate.path.replace(':id', id))}
              />
            </div>
          </div> */}
        </div>
        <Box title={PageTitle}>
          <Container>
            <Row>
              <Col xs={12} sm={12} md={{ span: 8, offset: 2 }}>
                {course && (
                  <div className="d-flex align-items-center flex-column">
                    <div className="ProcedureTrainingPlanPage__title py-4">{PageTitle}</div>
                    <div className="ProcedureTrainingPlanPage__body">
                      <div className="ProcedureTrainingPlanPage__body__item">
                        <div className="ProcedureTrainingPlanPage__body__item__label">{"Lớp học:"}</div>
                        <div className="ProcedureTrainingPlanPage__body__item__value">{course.fields.Title}</div>
                      </div>
                      <div className="d-flex">
                        <div className="ProcedureTrainingPlanPage__body__item">
                          <div className="ProcedureTrainingPlanPage__body__item__label">{"Ngày bắt đầu:"}</div>
                          <div className="ProcedureTrainingPlanPage__body__item__value">
                            {getDDMMYYYFormat(course.fields.eStartDate)}
                          </div>
                        </div>
                        <div className="ProcedureTrainingPlanPage__body__item">
                          <div className="ProcedureTrainingPlanPage__body__item__label">{"Ngày kết thúc:"}</div>
                          <div className="ProcedureTrainingPlanPage__body__item__value">
                            {getDDMMYYYFormat(course.fields.eEndDate)}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="ProcedureTrainingPlanPage__body__item">
                          <div className="ProcedureTrainingPlanPage__body__item__label">{"Giáo viên:"}</div>
                          <div className="ProcedureTrainingPlanPage__body__item__value">{course.fields.eTeacher}</div>
                        </div>
                        <div className="ProcedureTrainingPlanPage__body__item">
                          <div className="ProcedureTrainingPlanPage__body__item__label">{"Số lượng học viên:"}</div>
                          <div className="ProcedureTrainingPlanPage__body__item__value">
                            {course.fields.eNoOfTrainee}
                          </div>
                        </div>
                      </div>

                      <div className="ProcedureTrainingPlanPage__body__item">
                        <div className="ProcedureTrainingPlanPage__body__item__label">{"Nội dung đào tạo:"}</div>
                        <div className="ProcedureTrainingPlanPage__body__item__value">{course.fields.eContent}</div>
                      </div>
                      {(course.fields.eStatus === courseStatus.open ||
                        course.fields.eStatus === courseStatus.waitingapproval) && (
                        <div className="InputWraper">
                          {course.fields.eReviewComment && (
                            <>
                              <div className="mb-2 ProcedureTrainingPlanPage__body__item__label">Review's comments</div>
                              <div className="wraper">
                                <div>{course.fields.eReviewComment}</div>
                              </div>
                            </>
                          )}
                          {course.fields.eApprovedComment && (
                            <>
                              <div className="mb-2 ProcedureTrainingPlanPage__body__item__label">
                                Approval's comments
                              </div>
                              <div className="wraper">
                                <div>{course.fields.eApprovalComment}</div>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                      {previousPage === previousPages[2] && (
                        <div className="ProcedureTrainingPlanPage__body__table py-3">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>Mã NV</th>
                                <th>Họ và tên</th>
                                <th>Đơn vị</th>
                              </tr>
                            </thead>
                            <tbody>
                              {trainees.map((trainee: any) => (
                                <tr>
                                  <td>{trainee.employeeId}</td>
                                  <td>{trainee.name}</td>
                                  <td>{trainee.department}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </div>
                    <div className="ProcedureTrainingPlanPage__footer w-100">
                      {previousPage === previousPages[0] && (
                        <>
                          {course.fields.eStatus === courseStatus.waitingapproval && (
                            <>
                              <div className="InputWraper">
                                <div className="wraper">
                                  <div className="input">
                                    <textarea
                                      value={approvalComment}
                                      onChange={(e) => setApprovalComment(e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-center">
                                <div className="px-2">
                                  <Button
                                    className="mr5"
                                    buttonType="success"
                                    label="Phê duyệt"
                                    onClick={() => {
                                      onApproval(courseStatus.approved);
                                    }}
                                  />
                                </div>
                                <div className="px-2">
                                  <Button
                                    buttonType="grey"
                                    label="Từ chối"
                                    onClick={() => {
                                      onApproval(courseStatus.rejected);
                                    }}
                                  />
                                </div>
                              </div>
                            </>
                          )}
                          {course.fields.eStatus === courseStatus.waitingreview && (
                            <>
                              <div className="InputWraper">
                                <div className="wraper">
                                  <div className="input">
                                    <textarea
                                      value={reviewComment}
                                      onChange={(e) => setReviewComment(e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-center">
                                <div className="px-2">
                                  <Button
                                    className="mr5"
                                    buttonType="success"
                                    label="Đánh giá"
                                    onClick={() => {
                                      onReview(courseStatus.approved);
                                    }}
                                  />
                                </div>
                                <div className="px-2">
                                  <Button
                                    buttonType="grey"
                                    label="Từ chối"
                                    onClick={() => {
                                      onReview(courseStatus.rejected);
                                    }}
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                      {previousPage === previousPages[1] && (
                        <div className="d-flex justify-content-center">
                          {!IsRegistration && (
                            <>
                              <div className="px-2">
                                <Button className="mr5" buttonType="success" label="Đăng ký" onClick={onApply} />
                              </div>
                              <div className="px-2">
                                <Button buttonType="grey" label="Hủy" onClick={onCancle} />
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Box>
      </div>
    </div>
  );
});
